import React, { Component } from 'react';
import { Form } from 'antd';
import { debounce, values } from 'lodash';
import FormInstance from 'core/wrappers/FormInstance';

class Filter extends Component {
  constructor(props) {
    super(props);
    this.onChangeDebounce = debounce((value) => props.onChange(value), 800);
  }

  handleSubmit = ({ filterText }, allValues) => {
    const { onChange, onBeforeSubmit, onSearch } = this.props;

    let values = allValues;

    if (onBeforeSubmit) {
      values = onBeforeSubmit(values);
    }

    if (filterText !== undefined) {
      this.onChangeDebounce(values);

      if (onSearch) {
        onSearch(filterText);
      }
    } else if (onChange) {
      onChange(values);
    }
  };

  submit = () => {
    const { form } = this.props;

    form.validateFields().then((values) => {
      this.handleSubmit({}, values);
    });
  };

  handleSetValues = (params = {}) => {
    const { form } = this.props;

    if (form) {
      form.setFieldsValue({ ...params });
    }
  };

  handleBeforeBinding = (values) => {
    const { onBeforeBinding } = this.props;

    if (onBeforeBinding) {
      return onBeforeBinding(values);
    }

    return values;
  };

  render() {
    const {
      children,
      queryParams,
      form,
      formProps = {},
      autoSubmit = true
    } = this.props;

    return (
      <Form
        form={form}
        layout="inline"
        className="gx-filter-form"
        onValuesChange={autoSubmit ? this.handleSubmit : undefined}
        initialValues={this.handleBeforeBinding(queryParams ?? {})}
        preserve
        {...formProps}
      >
        {typeof children === 'function'
          ? children({ form, setValues: this.handleSetValues })
          : React.cloneElement(children, {
              setValues: this.handleSetValues,
              form
            })}
      </Form>
    );
  }
}

export default FormInstance.create(Filter);
